var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalstores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7503 33.5566H32.0837V39.39H78.7503V33.5566ZM81.667 62.7233V56.89L78.7503 42.3066H32.0837L29.167 56.89V62.7233H32.0837V80.2233H61.2503V62.7233H72.917V80.2233H78.7503V62.7233H81.667ZM55.417 74.39H37.917V62.7233H55.417V74.39Z",
    fill: "#CE0E2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3901,
    cy: 56.3325,
    r: 54.4444,
    stroke: "#CE0E2D",
    strokeWidth: 3.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalstores);
export default __webpack_public_path__ + "static/media/totalstores.1549d49a4446581b41e176cd84d22e7b.svg";
export { ForwardRef as ReactComponent };